import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { FiLoader } from 'react-icons/fi';
import './ProtectedRoute.css';

const ProtectedRoute = ({ children, requiredPermission = 'viewer' }) => {
  const { isAuthenticated, loading, hasPermission } = useAuth();
  const location = useLocation();

  // Mostrar loading enquanto verifica autenticação
  if (loading) {
    return (
      <div className="protected-route-loading">
        <div className="loading-container">
          <FiLoader className="loading-spinner" />
          <p>Verificando permissões...</p>
        </div>
      </div>
    );
  }

  // Se não estiver autenticado, redirecionar para login
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Se estiver autenticado mas não tem permissão necessária
  if (requiredPermission && !hasPermission(requiredPermission)) {
    return (
      <div className="permission-denied">
        <div className="permission-denied-content">
          <h2>Acesso Negado</h2>
          <p>Você não tem permissão para acessar esta página.</p>
          <button 
            onClick={() => window.history.back()}
            className="btn btn-secondary"
          >
            Voltar
          </button>
        </div>
      </div>
    );
  }

  // Se tudo estiver ok, renderizar o componente filho
  return children;
};

export default ProtectedRoute; 